import React from 'react';
// eslint-disable-next-line import/no-unresolved
import CSS from 'csstype';
import GoogleMap from '../GoogleMap';
import { useFranchiseeContext } from '../../context/Franchisee';

interface FranchiseeGoogleMapProps {
  // add franchisee google map props here
  className?: string;
  style?: CSS.Properties;
  zoomLevel?: number;
}

const FranchiseeGoogleMap: React.FC<FranchiseeGoogleMapProps> = ({
  className,
  style,
  zoomLevel,
}: FranchiseeGoogleMapProps) => {
  const {
    addressLineOne,
    city,
    state,
    zipCode,
    name,
  } = useFranchiseeContext()?.franchisee;

  return (
    <GoogleMap
      className={className}
      style={style}
      mapsString={`Two Maids ${addressLineOne} ${city} ${state} ${zipCode}`}
      title={`Two Maids ${name}`}
      zoomLevel={12}
    />
  );
};

FranchiseeGoogleMap.defaultProps = {
  // add franchisee google map default props here
  className: null,
  style: null,
  zoomLevel: null,
};

export default FranchiseeGoogleMap;
